const setStfEnabled = (stfData, stfBar, stfTitle, toggleText, enabled) => {
	stfBar.toggleClass('stf-enabled', enabled);
	if (enabled) {
		stfTitle.text(stfData.stfEnabledText);
		toggleText.text(stfData.disableText);
	} else {
		stfTitle.text(stfData.stfDisabledText);
		toggleText.text(stfData.enableText);
	}
};

const init = () => {
	if (typeof window.stfData === 'undefined') {
		return;
	}

	/* stfData object is defined on the page. */
	const stfData = window.stfData;
	const stfBar = jQuery('#wp-admin-bar-stf');
	const stfTitle = stfBar.find('.ab-item').first();
	const toggle = stfBar.find('#wp-admin-bar-stf-toggle').first();
	const toggleText = toggle.find('.ab-item').first();
	const inProgressClass = 'stf-in-progress';

	/* Set sending ajax query on click on the toggle. */
	toggle.on('click', () => {
		if (stfBar.hasClass(inProgressClass)) {
			return;
		}
		const enableAction = !stfBar.hasClass('stf-enabled');
		stfBar.addClass(inProgressClass);

		jQuery.ajax({
			url: stfData.ajaxurl,
			type: 'POST',
			data: {
				action: 'stf_toggle',
				enable: enableAction,
				_ajax_nonce: stfData.nonce,
			},
		}).done((response) => {
			setStfEnabled(stfData, stfBar, stfTitle, toggleText, response.data.enabled);
			stfBar.removeClass(inProgressClass);
		});
	});

	/* Reflect new STF status in admin bar after the submission's response. */
	jQuery(document).on('nfFormSubmitResponse', () => {
		setStfEnabled(stfData, stfBar, stfTitle, toggleText, false);
	});
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/send-test-form.js